import React, { useState, useContext } from 'react';
import './Navbar.css';
import { LocaleContext, AuthContext, WishlistContext, CartContext } from '../locale';

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [hoverCart, setHoverCart] = useState(false);
  const { locale, setLocale, t } = useContext(LocaleContext);
  const { user, openAuth, logout, loading, initializing } = useContext(AuthContext);
  const { wishlist, loading: wishlistLoading } = useContext(WishlistContext);
  const { cart } = useContext(CartContext);
  const itemsCount = Array.isArray(cart) ? new Set(cart.map(it => it.id)).size : 0;

  return (
    <header className="nav-wrap">
      <div className="container nav-inner">
        <div className="brand">
          <div className="brand-mark"></div>
          <div className="brand-text">
            <span className="brand-title">{t('nav.brandTitle')}</span>
          </div>
        </div>

        <nav className={`nav-links ${open ? 'open' : ''}`} id="primary-nav">
          <a href="#/" onClick={() => setOpen(false)}>{t('nav.explore')}</a>
          <a href="#/" onClick={() => setOpen(false)}>{t('nav.why')}</a>
          <a className="cta" href="#/products" onClick={() => setOpen(false)}>{t('nav.shop')}</a>
        </nav>

        <div style={{display:'flex', alignItems:'center', gap:8}}>
          {/* Cart icon - now navigates to cart page */}
          <a
            href="#/cart"
            className="nav-icon-btn cart"
            aria-label={t('nav.cart')}
            title={t('nav.cart')}
            onMouseEnter={() => setHoverCart(true)}
            onMouseLeave={() => setHoverCart(false)}
            style={{
              position: 'relative',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 40,
              height: 40,
              borderRadius: 10,
              background: hoverCart ? 'rgba(255,255,255,0.10)' : 'rgba(255,255,255,0.06)',
              border: '1px solid rgba(255,255,255,0.14)',
              transition: 'all .15s ease',
              boxShadow: hoverCart ? '0 8px 22px rgba(0,0,0,0.25)' : 'none',
              color: 'var(--text)'
            }}
          >
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="9" cy="21" r="1"></circle>
              <circle cx="20" cy="21" r="1"></circle>
              <path d="m1 1 4 4 2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
            </svg>
            {itemsCount > 0 && (
              <span
                className="nav-badge"
                style={{
                  position: 'absolute',
                  top: -6,
                  right: -6,
                  minWidth: 18,
                  height: 18,
                  padding: '0 6px',
                  borderRadius: 999,
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: 11,
                  fontWeight: 800,
                  background: 'linear-gradient(135deg, var(--accent), var(--accent-02))',
                  color: '#000',
                  border: '1px solid rgba(0,0,0,0.2)',
                  boxShadow: '0 6px 16px rgba(0,0,0,0.35)'
                }}
              >
                {itemsCount}
              </span>
            )}
          </a>

          {/* Wishlist icon - now navigates to page */}
          <a
            href="#/wishlist"
            className="nav-icon-btn"
            aria-label={t('nav.wishlist')}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
            </svg>
            {wishlistLoading ? (
              <span className="badge loading">...</span>
            ) : wishlist.length > 0 ? (
              <span className="badge">{wishlist.length}</span>
            ) : null}
          </a>

          <button
            className={`nav-toggle ${open ? 'open' : ''}`}
            onClick={() => setOpen(!open)}
            aria-label="menu"
            aria-expanded={open}
            aria-controls="primary-nav"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          {/* language toggle */}
          <div className="lang-switch" style={{display:'flex', gap:6, alignItems:'center'}}>
            <button
              className="btn secondary"
              onClick={() => setLocale(locale === 'en' ? 'fr' : 'en')}
              aria-label="switch language"
              style={{padding:'6px 10px', fontWeight:600}}
            >
              {locale === 'en' ? 'EN' : 'FR'}
            </button>
          </div>

          {/* auth actions */}
          {!user ? (
            <button
              className="btn secondary"
              onClick={() => openAuth('login')}
              disabled={loading || initializing}
              style={{padding:'6px 12px'}}
            >
              {initializing ? '...' : t('nav.login')}
            </button>
          ) : (
            <div className="user-pill">
              <div className="avatar" aria-hidden>
                {(user.fullName || user.email || '?').trim().charAt(0).toUpperCase()}
              </div>
              <span className="name" title={user.fullName || user.email}>
                {user.fullName || user.email}
                {user.role === 'admin' && <span style={{marginLeft: 4, fontSize: '0.8em', opacity: 0.7}}>(Admin)</span>}
              </span>
              <button className="btn secondary small" onClick={logout} style={{padding:'6px 10px'}}>
                {t('nav.logout')}
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}